import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { authApiService } from "../../api/api";
import ExpiringProductsTable from "../../components/Tables/ExpiringProductsTable";
import NewOrdersTable from "../../components/Tables/NewOrdersTable";
import TableTitle from "../../components/TableTitle/TableTitle";
import { IOrder } from "../../types/order.type";
import { IProduct } from "../../types/product.type";
import styles from "./styles.module.scss";

const MainPage: React.FC = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState<IProduct[]>([]);
  const [orders, setOrders] = useState<IOrder[]>([]);

  const getProducts = async () => {
    try {
      const results = await authApiService.getAllExpiringProducts();
      return results;
    } catch (err: any) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const getOrders = async () => {
    try {
      const results = await authApiService.getAllNewPaidOrders();
      return results;
    } catch (err: any) {
      console.error(err);
      toast.error(err.message);
    }
  };

  useEffect(() => {
    (async () => {
      const data = await getProducts();
      if (data) {
        setProducts(data);
      }
      const ord = await getOrders();
      if (ord) {
        setOrders(ord);
      }
    })();
  }, []);

  return (
    <main className={styles.container}>
      <div className={styles.header}>
        <TableTitle title="New orders" count={orders?.length || 0} />
      </div>
      <NewOrdersTable
        orders={orders}
        onPressLink={(id) =>
          navigate({
            pathname: "/orders",
            search: `?item=${id}`,
          })
        }
      />
      <div className={styles.header}>
        <TableTitle title="Products" count={products?.length || 0} />
      </div>
      <ExpiringProductsTable
        products={products}
        onPressLink={(id) =>
          navigate({
            pathname: "/warehouse",
            search: `?item=${id}`,
          })
        }
      />
    </main>
  );
};

export default MainPage;
